import { ConfigProvider } from "antd";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Router, Switch } from "react-router-dom";
import { PageNotFound, PTPS, PTPSAuth } from "./components";
import {
  /*InitRoute, */ PublicRoute,
  history,
  ProtectedRoute,
} from "./framework";

function App({ device, screenSize }) {
  const fontSize = {
    desktop: 16,
    tablet: 15,
    mobile: 14,
  };

  const [width, setWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    function handleWindowSizeChange() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const deviceSize =
    width >= 992 ? "desktop" : width >= 576 ? "tablet" : "mobile";

  useEffect(() => {
    screenSize({ size: deviceSize });
  }, [deviceSize, screenSize]);

  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: fontSize[device.size],
          colorSplit: `rgba(5, 5, 5, 0.12)`,
        },
      }}
    >
      <Router history={history}>
        <Switch>
          {/* language: enUS, zhHK, zhCN */}
          {/* Default language: en-us */}
          <PublicRoute
            path="/auth/adfs/login"
            exact
            component={() => {
              if (process.env.REACT_APP_ADFS_LOGIN_URL)
                window.location.href = process.env.REACT_APP_ADFS_LOGIN_URL;
            }}
          />
          <PublicRoute
            path="/auth/adfs/logout"
            exact
            component={() => {
              if (process.env.REACT_APP_ADFS_LOGOUT_URL)
                window.location.href = process.env.REACT_APP_ADFS_LOGOUT_URL;
            }}
          />
          <PublicRoute
            path="/"
            exact
            component={() => {
              console.log("index.publicroute.adfs.login.redirect");
              if (process.env.REACT_APP_PTPS_URL)
                window.location.href = process.env.REACT_APP_PTPS_URL;
            }}
          />
          <ProtectedRoute path="/ptps" component={PTPS} />
          <PublicRoute path="/ptpsauth" exact component={PTPSAuth} />
          <PublicRoute component={PageNotFound} />
        </Switch>
      </Router>
    </ConfigProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    device: state.session.device,
  };
};

const mapDispatchToProps = (dispatch) => ({
  screenSize: (device) => {
    dispatch({ type: "SET-DEVICE", payload: device });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
